export default {
    login: '登录',
    register: '注册',
    forget: '找回密码',
    login_mobile_placeholder: '请输入手机号，用于登录系统',
    login_pwd_placeholder: '请输入密码',
    remember_me: '下次自动登录',
    forgot_pwd: '忘记密码',
    register_mobile_placeholder: '请输入手机号，用于登录系统',
    register_verify_placeholder: '请输入验证码',
    register_name_placeholder: '请输入真实姓名，便于提供服务时联系您',
    register_email_placeholder: '请输入邮箱',
    register_pwd_placeholder: '请输入密码',
    register_repwd_placeholder: '请再次输入密码',
    get_code_btn: '获取验证码',
    got_code_btn: '后重新获取',
    reset_btn: '重置',
    aggrement_pre_text: '我接受',
    aggrement_text: '展会服务平台用户注册协议',
    forget_mobile_placeholder: '请输入您的注册手机号，您将会受到验证码',
    forget_verify_placeholder: '请输入验证码',
    forget_pwd_placeholder: '请输入新密码',
    reset_pwd_btn: '重置密码',
    service_item: '服务条款',
    privacy: '隐私协议',
    contact: '联系我们',
    help_center: '帮助中心',
    reference: '推荐使用浏览器',
    google_chrome: '谷歌浏览器',
    browser: '360浏览器极速模式',
    download_chrome: '下载浏览器',
    browser_setting: '浏览器设置',
    return_index: '返回首页',
    change_mode: '360浏览器切换模式的方法',
    step_one: '步骤1: 点击"闪电"图标',
    step_two: '步骤2: 选择"极速模式"',
    notice_pre: '注意：使用360浏览器，需要IE浏览器的版本在10.0及10.0以上',
    IE_version: '查看IE浏览器版本',
    IE_setting_one: '点击IE浏览器右上角的"设置"按钮，开选择"关于Internet Explorer(A)"',
    IE_setting_two: '红色标记的前两位为IE浏览器版本，系统支持IE10及IE10以上版本',
    service_agreement: '智奥服务协议',
    service_agreement_title: '【导言】',
    service_agreement_1: '欢迎您使用智奥的服务！',
    service_agreement_2: '为使用智奥的服务，您应当阅读并遵守《智奥服务协议》（以下简称“本协议”）和《智奥隐私政策》。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制智奥责任的条款、对用户权利进行限制的条款、约定争议解决方式和司法管辖的条款（如第十八条相关约定）等，以及开通或使用某项服务的单独协议或规则。限制、免责条款或者其他涉及您重大权益的条款可能以加粗、加下划线等形式提示您重点注意。',
    service_agreement_3: '除非您已充分阅读、完全理解并接受本协议所有条款，否则您无权使用智奥服务。您点击“同意”或“下一步”，或您使用智奥服务，或者以其他任何明示或者默示方式表示接受本协议的，均视为您已阅读并同意签署本协议。本协议即在您与智奥之间产生法律效力，成为对双方均具有约束力的法律文件。',
    service_agreement_4: '如果您因年龄、智力等因素而不具有完全民事行为能力，请在法定监护人（以下简称"监护人"）的陪同下阅读和判断是否同意本协议，并特别注意未成年人使用条款。',
    service_agreement_5: '如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和/或所处国家或地区的法律。',
    privacy_aggrement: '智奥隐私协议',
    privacy_aggrement_title: '一、引言',
    privacy_aggrement_1: '智奥中智兴严格遵守法律法规，遵循以下隐私保护原则，为您提供更加安全、可靠的服务：',
    privacy_aggrement_2: '1、安全可靠：',
    privacy_aggrement_3: '我们竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失。',
    privacy_aggrement_4: '2、自主选择：',
    privacy_aggrement_5: '我们为您提供便利的信息管理选项，以便您做出合适的选择，管理您的个人信息。',
    privacy_aggrement_6: '3、保护通信秘密：',
    privacy_aggrement_7: '我们严格遵照法律法规，保护您的通信秘密，为您提供安全的通信服务。',
    privacy_aggrement_8: '4、合理必要：',
    privacy_aggrement_9: '为了向您和其他用户提供更好的服务，我们仅收集必要的信息。',
    privacy_aggrement_10: '5、清晰透明：',
    privacy_aggrement_11: '我们努力使用简明易懂的表述，向您介绍隐私政策，以便您清晰地了解我们的信息处理方式。',
    privacy_aggrement_12: '6、将隐私保护融入产品设计：',
    register_agreement_title: '智奥会展（深圳）用户注册协议',
    register_agreement_1: '本协议是您与智奥会展(深圳)网站(简称"本站"，网址:www.zzxes.com.cn)所有者(以下简称为"智奥会展(深圳)")之间就智奥会展(深圳)网站服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您点击"同意并继续"按钮后，本协议即构成对双方有约束力的法律文件。',
    register_agreement_2: '第1条 本站服务条款的确认和接纳',
    register_agreement_3: '1.1本站的各项电子服务的所有权和运作权归智奥会展(深圳)所有。用户同意所有注册协议条款并完成注册程序，才能成为本站的正式用户。用户确认:本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。',
    register_agreement_4: '1.2用户点击同意本协议的，即视为用户确认自己具有享受本站服务、下单等相应的权利能力和行为能力，能够独立承担法律责任。',
    register_agreement_5: '1.3智奥会展(深圳)保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。',
    register_agreement_6: '第2条 本站服务',
    register_agreement_7: '2.1智奥会展(深圳)通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及本站规定的情况下，方有权使用。',
    contact_us_title: '联系我们',
    contact_us_1: '如果有任何疑问，请联系：',
    contact_man: '技术支持',
    error_verify_code: '验证码不正确',
    reg_code: '请填写手机号后再获取验证码',
    input_error_code: '验证码输入错误'
  }


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/login.js